import { Component, OnInit } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent } from '@icc/configurator/shared';


@Component({
    selector: 'icc-mounting-method-page',
    templateUrl: './mounting-method-page.component.html',
    styleUrls: ['./mounting-method-page.component.scss'],
    standalone: false
})
export class MountingMethodPageComponent extends PageComponent implements OnInit {
  public title: string = _('WINDOW|Wybierz sposób montażu');
  public options = [];

  constructor() {
    super()
  }

  ngOnInit() {
  }

}
